import { Check, X, Phone, Clock, CalendarCheck, FileCheck2 } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "@/lib/api";

const OLD_WAY = [
  "Obvolávanie a hľadanie firiem",
  "Neisté a neporovnateľné ceny",
  "Dlhé čakanie na ponuky",
  "Neoverení realizátori",
  "Žiadna jednotná záruka",
];
const OUR_WAY = [
  "Orientačná cena online do 60 sekúnd",
  "Transparentný rozpis: materiál, práca, lešenie, doprava",
  "Overený partner priamo vo vašom okrese",
  "Porovnanie s trhovým priemerom",
  "Záruka 36 mesiacov na prácu a 60 na materiál",
];

const STEPS = [
  { icon: Clock, t: "1. Ozveme sa do 24 hodín", d: `Po odoslaní vás kontaktujeme — aj telefonicky na ${PHONE_DISPLAY}.` },
  { icon: CalendarCheck, t: "2. Bezplatná obhliadka", d: "Dohodneme termín obhliadky, ktorý vám vyhovuje. Zdarma a nezáväzne." },
  { icon: FileCheck2, t: "3. Presná cenová ponuka", d: "Dostanete konkrétnu ponuku na kľúč od overeného partnera." },
];

export default function WhyUs() {
  return (
    <section id="preco-my" className="bg-ink-2 py-20 md:py-28 border-t border-white/10" data-testid="why-us">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <p className="font-mono2 text-gold uppercase tracking-[0.3em] text-xs mb-5">Prečo cez nás</p>
        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] text-white max-w-3xl">
          Prečo Zateplenia.eu a nie <span className="text-gold">klasický dopyt</span>
        </h2>

        {/* comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-12">
          <div className="border border-white/10 bg-ink p-7" data-testid="compare-old">
            <h3 className="text-white/60 font-semibold mb-5 uppercase tracking-widest text-xs font-mono2">Klasický spôsob</h3>
            <ul className="space-y-3">
              {OLD_WAY.map((x) => (
                <li key={x} className="flex items-start gap-3 text-white/50 text-sm"><X className="w-4 h-4 text-red-400/70 shrink-0 mt-0.5" /> {x}</li>
              ))}
            </ul>
          </div>
          <div className="border border-gold/40 bg-gold/[0.05] p-7" data-testid="compare-us">
            <h3 className="text-gold font-semibold mb-5 uppercase tracking-widest text-xs font-mono2">Cez Zateplenia.eu</h3>
            <ul className="space-y-3">
              {OUR_WAY.map((x) => (
                <li key={x} className="flex items-start gap-3 text-white/80 text-sm"><Check className="w-4 h-4 text-emerald-400 shrink-0 mt-0.5" /> {x}</li>
              ))}
            </ul>
          </div>
        </div>

        {/* what happens next */}
        <h3 className="font-display text-2xl md:text-3xl text-white mt-16 mb-2">Čo sa stane po odoslaní?</h3>
        <p className="text-white/50 text-sm mb-8 max-w-2xl">Žiadne záväzky. Celý proces od kalkulácie po ponuku je bezplatný.</p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {STEPS.map((s) => (
            <div key={s.t} className="border border-white/10 bg-ink p-6" data-testid={`next-step-${s.t[0]}`}>
              <s.icon className="w-8 h-8 text-gold mb-4" />
              <div className="text-white font-semibold mb-1">{s.t}</div>
              <p className="text-white/55 text-sm leading-relaxed">{s.d}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <span className="text-white/60 text-sm">Chcete sa najskôr opýtať? Zavolajte nám:</span>
          <a href={`tel:${PHONE_TEL}`} data-testid="whyus-phone" className="inline-flex items-center gap-2 bg-gold text-ink px-6 py-3 font-bold uppercase tracking-wider text-sm hover:bg-gold-light transition-colors">
            <Phone className="w-4 h-4" /> {PHONE_DISPLAY}
          </a>
        </div>
      </div>
    </section>
  );
}
